import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { RxStompService } from '../../shared/helpers/stomp-ws/rx-stomp.service';
import { webSocketHeaders } from '../../shared/helpers/stomp-ws/stomp.config';
import { StorageService } from './storage.service';

interface IResponse {
  data: {
    token: {
      access_token: string;
    };
    user: {
      admin: boolean;
      email: string;
      first_name: string;
      id: number;
      last_name: string;
      phone: string;
      show_customer_data: boolean;
      super_manager: boolean;
    };
  };
}

@Injectable()
export class RecoveryService {
  private subject = new Subject<void>();

  constructor(
    private http: HttpClient,
    private rxStompService: RxStompService,
    private storageService: StorageService
  ) {}

  private handleSuccess = (response: IResponse) => {
    this.storageService.setToken(response.data.token.access_token);
    this.rxStompService.configure({ connectHeaders: webSocketHeaders() });
    this.storageService.setCurrentUser({ ...response.data.user } as any);
    this.subject.next();
    this.storageService.removeRecoveryEmail();
  };

  sendEmail = (email: string): Observable<void> =>
    this.http
      .put(`${environment.apiUrl}/password-reminder`, { email })
      .pipe(map(() => this.storageService.setRecoveryEmail(email)));
  confirm = (data: any) =>
    this.http
      .put(`${environment.apiUrl}/users/password`, data)
      .pipe(map(r => this.handleSuccess(r as IResponse)));
}
